import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function UserProfile() {
  const userDetails = useSelector((state) => state?.auth?.loggedInUser);

  const getInitial = (name) => {
    return name && typeof name === "string"
      ? name.charAt(0).toUpperCase()
      : "?";
  };

  return (
    <Link to="/new-admin-dashboard/user-profile">
      <div className="p-4 border-t flex items-center">
        <div className="w-10 h-10 rounded-full bg-gray-300 mr-3 overflow-hidden">
          <div className="flex items-center">
            <div className="flex-shrink-0 h-10 w-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-medium">
              {getInitial(userDetails.name)}
            </div>
          </div>
        </div>
        <div>
          <p className="font-medium">{userDetails?.name}</p>
          <p className="text-xs text-gray-500">Admin</p>
        </div>
      </div>
    </Link>
  );
}
